import { render, staticRenderFns } from "./producto_crud.vue?vue&type=template&id=b9389f7e&scoped=true"
import script from "./producto_crud.vue?vue&type=script&lang=js"
export * from "./producto_crud.vue?vue&type=script&lang=js"
import style0 from "./producto_crud.vue?vue&type=style&index=0&id=b9389f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9389f7e",
  null
  
)

export default component.exports